// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2qWut","row":"Node_row__1VHXk","label":"Node_label__LbiO_","footer":"Node_footer__3BE_p"};